import { render } from "./CIS-Masthead-Two-Column-Link.vue?vue&type=template&id=84c5c256"
import script from "./CIS-Masthead-Two-Column-Link.vue?vue&type=script&lang=js"
export * from "./CIS-Masthead-Two-Column-Link.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__